const CONTACT_REQUIRED_FIELDS = ["type", "name", "emailAddress", "content"]

export const RequiredFields = {
  CONTACT_REQUIRED_FIELDS,
}
